class UsagiStepTextRender {

    constructor(props) {

        this.speed = props.speed || 500; // 文字表示の速度（ミリ秒）
        this.max = props.max || 5000; // 最大秒数
        this.isStopped = false;
        this.onUpdate = props.onUpdate || function() {}; // レンダリングの進行状況を報告するコールバック
        this.onComplete = props.onComplete || function() {}; // レンダリング完了時のコールバック
        this.outputElement = props.outputElement || null; // 出力先の要素を保持

        if (typeof props.inputElement === 'string') {
            this.inputHTML = props.inputElement;
        } else if (props.inputElement instanceof HTMLElement) {
            this.inputHTML = props.inputElement.innerHTML;
        } else {
            throw new Error('Invalid inputElement type. Expected string or HTMLElement.');
        }

        this.totalChars = this.countChars(this.inputHTML);
        this.charSpeed = Math.min(this.speed, this.max / this.totalChars);

    }

    countChars(html) {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.innerText.length;
    }

    async onInit() {
        const containerElement = document.createElement('div');
        containerElement.innerHTML = this.inputHTML;
        const jsonArray = this.parseHTML(containerElement);
        await this.renderHTML(jsonArray, this.outputElement);
        this.onComplete(); // レンダリング完了時にコールバック関数を呼び出す
    }

    parseElement(element) {
        if (['script', 'iframe', 'link', 'style'].includes(element.tagName.toLowerCase())) {
            return null;
        }
        const obj = { type: element.tagName.toLowerCase(), children: [], attribute: [] };
        Array.from(element.attributes).forEach(attr => {
            if (!['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onchange'].includes(attr.name.toLowerCase())) {
                obj.attribute.push({ [attr.name]: attr.value });
            }
        });
        element.childNodes.forEach(child => {
            if (child.nodeType === Node.TEXT_NODE) {
                obj.children.push({ type: 'planeText', value: child.textContent });
            } else if (child.nodeType === Node.ELEMENT_NODE) {
                const childObj = this.parseElement(child);
                if (childObj) obj.children.push(childObj);
            }
        });
        return obj;
    }

    parseHTML(containerElement) {
        return Array.from(containerElement.childNodes)
            .filter(node => node.nodeType === Node.ELEMENT_NODE)
            .map(node => this.parseElement(node))
            .filter(node => node !== null);
    }

    async renderText(text, parent) {
        const textNode = document.createTextNode('');
        parent.appendChild(textNode);
        for (const char of text.split('')) {
            if (this.isStopped) break;
            textNode.nodeValue += char;
            this.onUpdate(); // 進行状況の報告
            await new Promise(resolve => setTimeout(resolve, this.charSpeed));
        }
    }

    async renderElement(element, parent) {
        if (this.isStopped) return;
        const newElement = document.createElement(element.type);
        parent.appendChild(newElement);

        if (element.attribute) {
            element.attribute.forEach(attr => {
                const key = Object.keys(attr)[0];
                newElement.setAttribute(key, attr[key]);
            });
        }

        for (const child of element.children) {
            if (this.isStopped) break;
            if (child.type === 'planeText') {
                await this.renderText(child.value, newElement);
            } else {
                await this.renderElement(child, newElement);
            }
        }
    }

    async renderHTML(jsonArray, outputElement) {
        for (const element of jsonArray) {
            if (this.isStopped) break;
            await this.renderElement(element, outputElement);
        }
    }

    stopRendering() {
        this.isStopped = true;
    }

    onDestroy( p = { clearHtml : false } ) {
        this.isStopped = true; // さらなる描画を停止
        if ( this.outputElement && p.clearHtml ) {
            this.outputElement.innerHTML = ''; // 出力要素をクリア
        }
    }
}




export default UsagiStepTextRender;
